import { render, staticRenderFns } from "./CreateModuleModal.vue?vue&type=template&id=bdc8b7d4&"
import script from "./CreateModuleModal.vue?vue&type=script&lang=ts&"
export * from "./CreateModuleModal.vue?vue&type=script&lang=ts&"
import style0 from "./CreateModuleModal.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports